<template>
  <div>
    <div class="position-relative">
      <div
        class=" coinsValue position-absolute d-flex align-items-center bg-light px-2 py-1 rounded-pill atm-shadow"
      >
        <div class="h-100 mr-2">
          <img src="@/assets/coin2.png" alt="" class="h-100" />
        </div>
        <span>
          {{ rewardData.coins_required }}
        </span>
      </div>
      <button
        v-if="!rewardBank"
        type="button"
        class="favouriteButton position-absolute material-icons-round p-0"
        :class="favoriteButtonStyle"
        @click="updateStatusFavorite"
      >
        star
      </button>
      <b-dropdown
        v-if="userIsParent && !rewardBank && parentCanEdit"
        no-caret
        variant="none"
        class="dropdownStyle position-absolute bg-light rounded-pill p-1 atm-shadow"
        toggle-class="d-flex p-0"
      >
        <template #button-content class="text-decoration-none">
          <i class="material-icons text-dark ">more_horiz</i>
        </template>
        <button
          @click="openModalUpdateReward(rewardData)"
          class="dropdownItem text-dark d-flex p-2 w-100"
        >
          <i class="material-icons">edit</i>
          <span class=" font-weight-bold text-capitalize text-center">
            Edit
          </span>
        </button>
        <button @click="modalDeleteReward" class="dropdownItem text-danger d-flex p-2 w-100">
          <i class="material-icons ">delete</i>
          <span class=" font-weight-bold text-capitalize text-center">
            Delete
          </span>
        </button>
      </b-dropdown>
      <div class="rewardImage">
        <img
          :src="
            rewardData.attachment ? rewardData.attachment : require(`@/assets/empty-rewards.jpg`)
          "
          class="atm-rounded-top"
        />
      </div>
    </div>
    <div class="d-flex flex-column justify-items-center align-items-center p-3 w-100">
      <p
        class="reward-name text-blue-dark font-weight-bold h5 w-100"
        v-b-tooltip
        :title="rewardData.name"
      >
        {{ rewardData.name }}
      </p>
      <div
        v-if="!rewardData.claimed && !rewardBank"
        class="d-flex flex-wrap justify-items-center align-items-center w-100"
      >
        <div v-if="rewardData.coins_required <= coinsBanked" class="d-flex flex-wrap w-100">
          <small class="mb-2 w-100">
            <span class="font-weight-bold text-orange">
              {{ rewardData.coins_required }}
            </span>
            coins to claim
          </small>
          <button
            v-if="!userIsParent"
            class="claimButton atm-button bg-main bottom-0 w-50 mx-auto"
            @click="claimReward"
          >
            Claim
          </button>
          <button
            v-else-if="parentCanEdit"
            class="claimButton atm-button text-center bg-main bottom-0 w-75 mx-auto"
            @click="claimReward"
          >
            Ready to claim
          </button>
        </div>
        <div v-else class="d-flex flex-grow flex-wrap w-100">
          <small class="mb-2">
            You need
            <span class="font-weight-bold text-orange">
              {{ rewardData.coins_required - coinsBanked }} coins
            </span>
            more
          </small>
          <b-progress :max="rewardData.coins_required" class="progress-bar rounded-pill w-100">
            <b-progress-bar
              :value="coinsBanked"
              :label="`${((coinsBanked / rewardData.coins_required) * 100).toFixed(1)}%`"
              class="progress rounded-pill"
              show-progress
              animated
            ></b-progress-bar>
          </b-progress>
        </div>
      </div>
    </div>
    <span v-if="!rewardBank" class="labelDate text-blue-dark">
      <b>Last Claimed:</b>
      {{
        rewardData.last_claimed_date ? formatLongDateTime(rewardData.last_claimed_date) : 'Never'
      }}
    </span>
  </div>
</template>
<script>
import { useSessionStore } from '@/common';
import { formatLongDateTime } from '@/common/utils/Date';

export default {
  data() {
    const sessionStore = useSessionStore();
    return {
      sessionStore,
      formatLongDateTime,
    };
  },
  props: {
    rewardData: {
      type: Object,
    },
    userIsParent: {
      type: Boolean,
      default: false,
    },
    coinsBanked: {
      type: Number,
      default: 0,
    },
    rewardBank: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    favoriteButtonStyle() {
      return this.rewardData?.favorite ? 'favouriteColor' : 'text-light';
    },
    parentCanEdit() {
      return this.sessionStore.getCurrentChild.parentCanEdit;
    },
  },
  methods: {
    updateStatusFavorite() {
      this.$emit('changeFavorite');
    },
    openModalUpdateReward(rewardData) {
      this.$emit('openModalUpdateReward', { rewardData });
    },
    modalDeleteReward() {
      this.$emit('deleteReward');
    },
    claimReward() {
      this.$emit('claimReward');
    },
  },
};
</script>
<style lang="scss" scoped>
.fit-image {
  width: 100%;
  height: 120px;
  object-fit: cover;
}

.fit-image-horizontal {
  width: 100%;
  height: 100px;
  object-fit: cover;
}

.biger-icon {
  font-size: 5em !important;
}

.close {
  right: 10px;
}

.coinsValue {
  height: 30px;
  top: 10px;
  left: 10px;
  & > div {
    position: relative;
    top: -2px;
    height: 100%;
    & > img {
      object-fit: contain;
    }
  }
}

.favouriteButton {
  background-color: transparent;
  font-size: 2rem;
  top: 10px;
  right: 10px;
  border: none;
  text-shadow: 2px 2px 6px rgb(0 0 0 / 25%);
}

.favouriteColor {
  color: #ff7648;
}

.dropdownStyle {
  right: 10px;
  bottom: 10px;
}

.dropdownItem {
  background-color: transparent;
  border: none;
}

.rewardImage {
  width: 100%;
  height: 200px;
  & > img {
    box-shadow: 0 5px 14px -10px #888;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.claimButton {
  height: min-content;
}

.reward-name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.labelDate {
  font-size: 12px;
  margin-top: 8px;
  margin-left: 20px;
}

.progress-bar {
  height: 25px;
  background-color: #e9ecef;
  & .progress {
    background-color: #f9c132;
    color: black;
    font-weight: 500;
  }
}
</style>
